module.exports = __webpack_public_path__ + "assets/img/enterIcon2.bab2be11.png";